var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 11.8083C8.2249 11.8083 6.7749 10.3667 6.7749 8.58334C6.7749 6.8 8.2249 5.36667 9.9999 5.36667C11.7749 5.36667 13.2249 6.80834 13.2249 8.59167C13.2249 10.375 11.7749 11.8083 9.9999 11.8083ZM9.9999 6.61667C8.91657 6.61667 8.0249 7.5 8.0249 8.59167C8.0249 9.68334 8.90824 10.5667 9.9999 10.5667C11.0916 10.5667 11.9749 9.68334 11.9749 8.59167C11.9749 7.5 11.0832 6.61667 9.9999 6.61667Z",
    fill: "#313131",
    stroke: "#313131",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 18.9667C8.76657 18.9667 7.5249 18.5 6.55824 17.575C4.0999 15.2083 1.38324 11.4333 2.40824 6.94166C3.33324 2.86666 6.89157 1.04166 9.9999 1.04166C9.9999 1.04166 9.9999 1.04166 10.0082 1.04166C13.1166 1.04166 16.6749 2.86666 17.5999 6.94999C18.6166 11.4417 15.8999 15.2083 13.4416 17.575C12.4749 18.5 11.2332 18.9667 9.9999 18.9667ZM9.9999 2.29166C7.5749 2.29166 4.45824 3.58332 3.63324 7.21666C2.73324 11.1417 5.1999 14.525 7.43324 16.6667C8.8749 18.0583 11.1332 18.0583 12.5749 16.6667C14.7999 14.525 17.2666 11.1417 16.3832 7.21666C15.5499 3.58332 12.4249 2.29166 9.9999 2.29166Z",
    fill: "#313131",
    stroke: "#313131",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location-outline.9ce693ae7908cad862e6273421a50188.svg";
export { ForwardRef as ReactComponent };